
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Projects from "./Pages/Projects/Projects";
import User from "./Pages/Users/UserManagement";
import MapComponent from "./Pages/GIS Portal/MapComponent";
import TreeSpecies from "./Pages/Tree Species/TreeSpecies";
import SubscriptionManagement from "./Pages/Subscriptions/SubscriptionManagement";
import Login from "./Pages/Auth/Login";
import UserForm from "./Pages/Users/UserForm";
import UserView from "./Pages/Users/UserView";
import AddUser from "./Pages/Users/AddUser";
import Management from "./Pages/Users/Management";
import Subscription from "./Pages/Subscriptions/Subscription";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  // Check sessionStorage for authentication data on mount
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const storedUser = sessionStorage.getItem("user");

    if (accessToken && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setIsAuthenticated(true);
        setUser(parsedUser);
      } catch (err) {
        console.error("Failed to parse user data from sessionStorage", err);
        sessionStorage.clear(); // Clear invalid data
      }
    }
  }, []); // Empty dependency array to run only on mount

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    sessionStorage.clear(); // Clear sessionStorage on logout
  };

  return (
    <Router>
      {isAuthenticated ? (
        <AuthenticatedApp user={user} handleLogout={handleLogout} />
      ) : (
        <Routes>
          <Route path="*" element={<Login onLogin={handleLogin} />} />
        </Routes>
      )}
    </Router>
  );
}

function AuthenticatedApp({ user, handleLogout }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname === "/login" || window.location.pathname === "/") {
      navigate("/map", { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Sidebar */}
      <Sidebar user={user} onLogout={handleLogout} />

      {/* Main Content */}
      <div style={{ flex: 1, overflowY: "auto", height: "100vh" }}>
        <Routes>
          <Route path="/" element={<MapComponent />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user" element={<Management user={user} />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/tree-species" element={<TreeSpecies />} />
          <Route path="/map" element={<MapComponent />} />
          <Route path="/subscription" element={<Subscription user={user} />} />
          <Route path="/users/:id/edit" element={<UserForm isEdit={true} />} />
          <Route path="/users/:id/view" element={<UserView />} />
          <Route path="/users/add" element={<AddUser />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;